export default __webpack_public_path__ + "static/media/notification-bell.8599c5ce.svg";